import React, { useState } from "react";
import { languageIcon, emptyStateIcon, editIcon } from "../../../assets/Icons/icons";
import { strings } from "../../../strings/strings";

const CountryDataCard = ({ country, onEditEmail }) => {
  // eslint-disable-next-line no-unused-vars
  const [isEmailHovered, setIsEmailHovered] = useState(false);
  const { name, countryName, countryCode, supportedLanguages, languages, isOnline, status, country_email } =
    country || {};

  const countryDisplayName = countryName || name || "Unknown Country";
  const languageList = supportedLanguages || languages || [];
  const online = Boolean(isOnline);
  return (
    <div className="bg-white rounded-2xl border border-gray-200 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300 overflow-hidden">
      {/* Header */}
      <div className="px-5 py-4 bg-gradient-to-r from-slate-50 to-white border-b border-gray-100">
        <div className="flex items-start justify-between gap-3">
          <div>
            <h3 className="text-base font-semibold text-secondary">
              {countryDisplayName} <span className="text-base">({countryCode})</span>
            </h3>
          </div>

          <span
            className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-semibold border ${
              online ? "bg-green-50 text-green-700 border-green-200" : "bg-red-50 text-red-700 border-red-200"
            }`}
          >
            <span className={`w-2 h-2 rounded-full ${online ? "bg-green-500" : "bg-red-500"}`}></span>
            {online ? "Online" : "Offline"}
          </span>
        </div>
      </div>

      {/* Body */}
      <div className="p-5 space-y-5">
        {/* Languages */}
        <div>
          <div className="flex items-center gap-2 mb-3">
            <img src={languageIcon} alt="" className="w-4 h-4 opacity-80" />
            <p className="text-xs font-bold text-secondary uppercase tracking-wider">{strings.supportedlanguages}</p>
          </div>

          {languageList.length > 0 ? (
            <div className="flex flex-wrap gap-2">
              {languageList.map((lang, index) => (
                <span
                  key={index}
                  className="inline-flex items-center px-3 py-1.5 rounded-lg text-xs font-medium bg-blue-50 text-blue-700 border border-blue-100"
                >
                  {lang}
                </span>
              ))}
            </div>
          ) : (
            <div className="py-6 text-center bg-gray-50 rounded-xl border border-dashed border-gray-200">
              <img src={emptyStateIcon} alt="" className="w-8 h-8 mx-auto mb-2 opacity-50" />
              <p className="text-sm text-gray-400 font-medium">
                {strings.nolaungugeconfigured || "No language configured"}
              </p>
            </div>
          )}
        </div>
        <div 
          className="bg-gray-100 p-3 rounded-lg relative"
          onMouseEnter={() => setIsEmailHovered(true)}
          onMouseLeave={() => setIsEmailHovered(false)}
        >
          <div className="flex items-center justify-between">
            <div className="flex-1">
              <span className="text-sm text-secondary font-bold">{strings.email}:</span>
              <p className="text-xs font-bold text-secondary tracking-wider mt-1">{country_email || "N/A"}</p>
            </div>
      
              <button
                onClick={() => onEditEmail(country)}
                className="ml-2 bg-white rounded-xl p-2 shadow-sm hover:shadow-lg transition-all duration-200 hover:bg-gray-50"
                title="Edit Email"
              >
                <img src={editIcon} alt="Edit" className="w-3.5 h-3.5" />
              </button>
    
          </div>
        </div>
        {/* Backend Status Message */}
        <div className="rounded-xl border border-gray-100 bg-gray-100 p-2">
          <p className="text-xs text-secondary font-bold leading-6 break-words">{status || "--"}</p>
        </div>
      </div>
    </div>
  );
  
};

export default CountryDataCard;
